import React from 'react';
import { Col, Row } from 'reactstrap';
import { Grid, ThemeProvider, Typography } from '@mui/material';
import { Translate, translate } from 'react-jhipster';

// TODO refactor to reduce input params and move data into internal state where possible
export const InternationalCommodityForm = ({
  responsiveFont,
  getPurchaseColor,
  getTransferColor,
  getSellColor,
  getCancellationColor,
  purchaseDownloadCert,
  transferDownloadCert,
  sellDownloadCert,
  purchaseCancellation,
  PurchaseIcon,
  TransferIcon,
  SellIcon,
  CancelIcon,
}) => {
  return (
    <Row className="justify-content-center" style={{ marginTop: '12px' }}>
      <Col md="8" lg="6" className="round-border mt-1" style={{ padding: '28px 42px 28px 42px' }}>
        <ThemeProvider theme={responsiveFont}>
          <Typography variant="h6" component="div">
            <strong>{translate('comexApp.quotation.printCertificatesLabel')}</strong>
          </Typography>
        </ThemeProvider>

        <Grid style={{ marginTop: '24px' }} className="row">
          <Grid item xs={12} sm={6} md={4}>
            <div style={{ justifyContent: 'center', display: 'flex', marginBottom: '5%' }}>
              <PurchaseIcon style={{ width: '20px', height: '20px', color: getPurchaseColor() }} />
              <h6 style={{ color: getPurchaseColor() }}>
                <Translate contentKey="comexApp.quotation.purchaseLabel">Purchase</Translate>
              </h6>
            </div>

            {purchaseDownloadCert()}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div style={{ justifyContent: 'center', display: 'flex', marginBottom: '5%' }}>
              <TransferIcon style={{ width: '20px', height: '20px', color: getTransferColor() }} />
              <h6 style={{ color: getTransferColor() }}>
                <Translate contentKey="comexApp.quotation.transferLabel">Transfer</Translate>
              </h6>
            </div>
            {transferDownloadCert()}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div style={{ justifyContent: 'center', display: 'flex', marginBottom: '5%' }}>
              <SellIcon style={{ width: '20px', height: '20px', color: getSellColor() }} />
              <h6 style={{ color: getSellColor() }}>
                <Translate contentKey="comexApp.quotation.sellLabel">Sell</Translate>
              </h6>
            </div>
            {sellDownloadCert()}
          </Grid>
          <Grid item xs={12} sm={6} md={3} style={{ display: 'none' }}>
            <div style={{ justifyContent: 'center', display: 'flex', marginBottom: '5%' }}>
              <CancelIcon style={{ width: '20px', height: '20px', color: getCancellationColor() }} />
              <h6 style={{ color: getCancellationColor() }}>
                <Translate contentKey="comexApp.quotation.cancellationBtnLabel">Cancellation</Translate>
              </h6>
            </div>
            {purchaseCancellation && purchaseCancellation?.result === 'CANCELLED' ? (
              <div style={{ textAlign: 'center' }}>
                <a href={`/quotation/cancellation-certificate/${purchaseCancellation.id}`}>
                  <p style={{ color: getCancellationColor() }}>
                    <u>
                      <Translate contentKey="comexApp.quotation.printAlshmokhCert">Alshmokh</Translate>
                    </u>
                  </p>
                </a>
              </div>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <p style={{ color: getCancellationColor() }}>
                  <u>
                    <Translate contentKey="comexApp.quotation.printAlshmokhCert">Alshmokh</Translate>
                  </u>
                </p>
              </div>
            )}
          </Grid>
        </Grid>
      </Col>
    </Row>
  );
};
